
import Component from '../../../assets/scripts/modules/component'

export default class ArticleCookiesComponent extends Component {
  init () {
    this.observedIntersectionElements = this.element.querySelectorAll('.article-cookies__title, .article-cookies__text, .article-cookies__buttons')

    this.buttonChange = this.element.querySelector('.link--change')
    this.buttonClear = this.element.querySelector('.link--clear')

    this.buttonChange.addEventListener('click', event => {
      event.preventDefault()
      window.dispatchEvent(new CustomEvent('show-cookie-details'))
    })

    this.buttonClear.addEventListener('click', event => {
      event.preventDefault()
      window.dispatchEvent(new CustomEvent('clear-cookie-settings'))
    })
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.article-cookies').forEach(element => {
  element.instance = element.instance || new ArticleCookiesComponent(element)
}))
